'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import ErrorPageForm from '../ErrorPageForm';
import Logo from '../Logo';
import usageTracker from '../../lib/usageTracker';
import ErrorDetails from './ErrorDetails';
import { getDomain } from '../../selectors/Grader';
import { ROOT } from '../../constants/Paths';
export default (function () {
  var domain = useSelector(getDomain);
  useEffect(function () {
    if (domain) {
      usageTracker.logView('Error');
    }
  }, []);
  return domain ? /*#__PURE__*/_jsxs("div", {
    className: "error-page",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "errors/map",
      width: "150px"
    }), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx("div", {
      className: "title",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "meta.title"
      })
    }), /*#__PURE__*/_jsx(ErrorDetails, {}), /*#__PURE__*/_jsx(ErrorPageForm, {})]
  }) : /*#__PURE__*/_jsx(Redirect, {
    to: ROOT
  });
});